<template lang="pug">
  v-app
    v-container
      v-layout(justify-center row fill-height)
        v-flex(xs12 sm8 md7 lg6 xl4)
          v-card(class="pa-3 elevation-5")
            v-card-title(class="pb-0")
              v-layout(column class="text-xs-center")
                h1.display-1.font-weight-bold DolborDB
                h2.headline Конструктор баз данных
            v-card-text(class="pb-5")
              v-layout(justify-center)
                v-flex(xs4 class="mx-4")
                  v-img(
                    @click="goToInnAuth",
                    src="/static/images/inn.png",
                    alt="авторизация через инн")
                v-flex(xs4 class="mx-4")
                  v-img(
                    @click="goToSmartIdAuth",
                    src='/static/images/id.png',
                    alt="авторизация через смарт-айди")
</template>

<script>
export default {
  name: 'Enter',
  methods: {
    goToInnAuth() {
      this.$router.push({ path: '/auth/inn' })
    },
    goToSmartIdAuth() {
      this.$router.push({ path: '/auth/smart-id' })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  margin-top: 100px;
  .v-image {
    border: 1px solid #e5e5e5;
    border-radius: 4px;
  }
  .v-image:hover {
    //border-color: #007bff;
    cursor: pointer;
    -webkit-box-shadow: 1px 1px 19px 2px rgba(0, 123, 255, 0.75);
    -moz-box-shadow: 1px 1px 19px 2px rgba(0, 123, 255, 0.75);
    box-shadow: 1px 1px 19px 2px rgba(0, 123, 255, 0.75);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EnterPage/EnterPage.vue